import Index from './index.vue'
import Detail from './detail.vue'
import BlankLayout from '../layout/blankLayout.vue'

const prefixPath = '/v-admin/notification'

const route = [
  {
    name: 'notificationList',
    path: `${prefixPath}/list`,
    component: Index,
    meta: {
      titleI18nKey: 'admin.notification.title.list'
    }
  },
  {
    name: 'notificationDetail',
    path: `${prefixPath}/detail/:notificationId`,
    component: Detail,
    meta: {
      titleI18nKey: 'admin.notification.title.detail'
    }
  }
]

const notificationRoute = {
  name: 'notificationRoute',
  path: prefixPath,
  redirect: `${prefixPath}/list`,
  component: BlankLayout,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.notification.title.list'
  },
  children: route
}

export default notificationRoute
